import { SIZE_10MO_OCTETS, useTextes } from '@common/config';
import { Z_EMAIL, Z_FIRST_NAME, Z_JOB, Z_LAST_NAME, Z_PHONE, Z_SAVED_FILE } from '@common/schemas';
import { z } from 'zod';

const t = useTextes('Commun', 'Representants');

export const formSchemaRepresentant = z.object({
  lastName: Z_LAST_NAME,
  firstName: Z_FIRST_NAME,
  job: Z_JOB,
  phone: Z_PHONE,
  email: Z_EMAIL,
  legalFile: Z_SAVED_FILE({ errorMsg: t['REPR_MES11'], maxSize: SIZE_10MO_OCTETS }),
});

export const formSchemaRepresentantWithDelegataire = formSchemaRepresentant.extend({
  delegateLastName: Z_LAST_NAME,
  delegateFirstName: Z_FIRST_NAME,
  delegateJob: Z_JOB,
  delegateEmail: Z_EMAIL,
  delegateFile: Z_SAVED_FILE({ errorMsg: t['REPR_MES16'], maxSize: SIZE_10MO_OCTETS }),
}).superRefine((form, ctx) => {
  if (!!form.delegateEmail && form.email?.trim() === form.delegateEmail?.trim()) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'L\'adresse mail doit être différente de celle du délégataire.',
      path: ['email'],
    });
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'L\'adresse mail doit être différente de celle du Représentant légal.',
      path: ['delegateEmail'],
    });
  }
});

export type FormRepresentantFormResult = z.infer<typeof formSchemaRepresentant>;
export type FormRepresentantWithDelegataireFormResult = z.infer<typeof formSchemaRepresentantWithDelegataire>;
export type FormResultRepresentantDelegataire =
  FormRepresentantFormResult
  | FormRepresentantWithDelegataireFormResult;